module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Report Templates")]), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.templates,
      "fields": _vm.fields,
      "has-edit": "/templates/reports/edit/",
      "delete-endpoint": "reportTemplate/delete",
      "has-delete": true
    },
    on: {
      "modelChange": _vm.fetchTemplates
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183d4ee0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportTemplates.vue
// module id = 272
// module chunks = 0